import gql from 'graphql-tag'

export default gql`
  mutation ($_id: MongoID!,$expire: Date $member: EnumUserMember ){
    updateUser(
      _id:$_id,
      record:{
        expire: $expire,
        member: $member,
      })
      {
        recordId
      }
  }
`